import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

const login = async (email, password) => {
  const response = await api.post("/auth/login", { email, password });

  console.log("Login response data:", response.data);

  const token = response.data?.token || response.data?.access_token;
  const loggedInUser = response.data?.user;

  console.log("Token received:", Boolean(token));
  console.log("User received:", loggedInUser);

  if (!token) {
    throw new Error("No token was returned by the backend.");
  }

  window.localStorage.setItem("fh_token", token);

  console.log(
    "Token after saving:",
    window.localStorage.getItem("fh_token")
  );

  if (!loggedInUser) {
    throw new Error("No user details were returned by the backend.");
  }

  setUser(loggedInUser);

  return loggedInUser;
};
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", {
      name,
      email,
      password,
    });

    const token = data.token || data.access_token;

    if (!token) {
      console.error("Registration response:", data);
      throw new Error("The backend did not return a login token.");
    }

    localStorage.setItem("fh_token", token);
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("Logout error:", err);
    }

    localStorage.removeItem("fh_token");
    localStorage.removeItem("fh_farm");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}